import React, { useState } from "react";
import { Table, Tabs, Button, Input, Select, Pagination, Tag, Space, Typography, Modal, Form, InputNumber } from "antd";
import { Search, Filter, Upload, Edit, Trash2 } from "lucide-react";

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const RewardPointCategory = () => {
    const [activeTab, setActiveTab] = useState("1");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();

    const initialDataSource = [
        {
            key: '4',
            id: 4,
            sku: 'WAVERIDERTSPACK2023',
            name: "WaveRider Boys' Half Sleeve Blue Full Graphic Printed T-Shirt Pack",
            points: 30,
            status: 'Active',
        },
        {
            key: '3',
            id: 3,
            sku: 'DAZZLEPUMPS2023',
            name: "Dazzling Elegance Women's Black Stiletto Pumps with Diamonds",
            points: 20,
            status: 'Active',
        },
        {
            key: '2',
            id: 2,
            sku: 'CTPSS2023',
            name: "Blossom Breeze Cotton Printed Short Skirt",
            points: 10,
            status: 'Active',
        },
        {
            key: '1',
            id: 1,
            sku: 'shoes400',
            name: "AquaStride Men's Casual Sports Shoes",
            points: 40,
            status: 'Active',
        },
    ];

    const [tableData, setTableData] = useState(initialDataSource);

    const handleAddReward = (values) => {
        const newId = tableData.length > 0 ? Math.max(...tableData.map(item => item.id)) + 1 : 1;
        const newItem = {
            key: newId.toString(),
            id: newId,
            sku: values.sku,
            name: values.name,
            points: values.points,
            status: values.status || 'Active',
        };
        setTableData([newItem, ...tableData]);
        setIsModalOpen(false);
        form.resetFields();
    };

    const columns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
        },
        {
            title: 'SKU',
            dataIndex: 'sku',
            key: 'sku',
            align: 'center',
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '35%',
            render: (text) => <span style={{ color: '#64748b' }}>{text}</span>
        },
        {
            title: 'Reward Points',
            dataIndex: 'points',
            key: 'points',
            align: 'center',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (status) => (
                <Tag color="success" style={{ borderRadius: '12px', padding: '2px 12px', fontWeight: 500, background: '#10b981', color: '#fff', border: 'none' }}>
                    {status}
                </Tag>
            ),
        },
        {
            title: 'Actions',
            key: 'actions',
            align: 'center',
            render: () => (
                <Space size="middle">
                    <Button type="text" icon={<Edit size={16} color="#64748b" />} style={{ minWidth: 'auto', }} />
                    <Button type="text" icon={<Trash2 size={16} color="#64748b" />} style={{ minWidth: 'auto' }} />
                </Space>
            ),
        },
    ];

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },
    };

    return (
        <div className="reward-point-container" style={{ padding: '24px', background: '#fff', minHeight: '100vh' }}>

            <Tabs activeKey={activeTab} onChange={setActiveTab} className="reward-tabs">
                <TabPane tab="Reward Point on Category" key="1" />
                <TabPane tab="Reward Point on Category For Specific Time" key="2" />
            </Tabs>

            {activeTab === "1" && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                        <Title level={4} style={{ margin: 0, color: '#0f172a', fontWeight: 600 }}>Reward Point on Category</Title>
                        <Space size="middle">
                            <Button icon={<Upload size={16} />} style={{ display: 'flex', alignItems: 'center', borderRadius: '6px', color: '#64748b', fontWeight: 500, border: 'none', boxShadow: 'none' }}>
                                Export
                            </Button>
                            <Button
                                type="primary"
                                style={{ borderRadius: '6px', background: '#2563eb', fontWeight: 500 }}
                                onClick={() => setIsModalOpen(true)}
                            >
                                Create Category Reward
                            </Button>
                        </Space>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                        <Space size="large">
                            <Input
                                placeholder="Search"
                                suffix={<Search size={16} color="#94a3b8" />}
                                style={{ width: 250, borderRadius: '6px' }}
                            />
                            <Text style={{ color: '#64748b', fontSize: '13px' }}>{tableData.length} Results</Text>
                        </Space>
                        <Space size="middle">
                            <Button icon={<Filter size={16} color="#64748b" />} style={{ display: 'flex', alignItems: 'center', borderRadius: '6px', color: '#64748b' }}>
                                Filter
                            </Button>
                        </Space>
                    </div>

                    <Table scroll={{ x: 'max-content' }}
                        columns={columns}
                        dataSource={tableData}
                        pagination={true}
                        style={{ border: '1px solid #f1f5f9', borderRadius: '8px' }}
                        className="reward-table-custom"
                    />
                </>
            )}

            {activeTab === "2" && (
                <div>
                    <Title level={5} style={{ color: '#64748b' }}>Reward Point on Product For Specific Time Content</Title>
                </div>
            )}

            <Modal
                title="Create Product Reward"
                open={isModalOpen}
                onCancel={() => {
                    setIsModalOpen(false);
                    form.resetFields();
                }}
                footer={null}
                destroyOnClose
            >
                <div style={{ padding: '20px 0' }}>
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleAddReward}
                        initialValues={{ status: 'Active' }}
                    >
                        <Form.Item label="Name" name="name" rules={[{ required: true, message: 'Please enter product name' }]}>
                            <Input placeholder="Enter product name" />
                        </Form.Item>
                        <Form.Item label="SKU" name="sku" rules={[{ required: true, message: 'Please enter SKU' }]}>
                            <Input placeholder="Enter SKU" />
                        </Form.Item>
                        <Form.Item label="Reward Points" name="points" rules={[{ required: true, message: 'Please enter reward points' }]}>
                            <InputNumber min={0} style={{ width: '100%' }} placeholder="Enter points" />
                        </Form.Item>
                        <Form.Item label="Status" name="status">
                            <Select>
                                <Option value="Active">Active</Option>
                                <Option value="Inactive">Inactive</Option>
                            </Select>
                        </Form.Item>
                        <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                            <Space>
                                <Button onClick={() => { setIsModalOpen(false); form.resetFields(); }}>Cancel</Button>
                                <Button type="primary" htmlType="submit" style={{ background: '#2563eb' }}>Create</Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </div>
    );
};

export default RewardPointCategory;
